import { create } from "zustand";

/**
 * Profile Image Store
 * Replaces: profileImageUrlState from recLib/atoms/profile.ts
 *
 * Stores the Object URL created from cached blob in IndexedDB.
 * Shared across all components via the useProfileImage hook.
 */
type ProfileImageStoreType = {
  /** Blob URL of the cached profile image */
  profileImageUrl: string | null;

  /** Actions */
  setProfileImageUrl: (url: string | null) => void;
};

export const useProfileImageStore = create<ProfileImageStoreType>((set) => ({
  profileImageUrl: null,
  setProfileImageUrl: (url) => set({ profileImageUrl: url }),
}));
